module.exports = __webpack_public_path__ + "static/img/3.d5b6d71.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting711/images/3.png
// module id = +pEa
// module chunks = 4